export default function Footer({ t }) {
  return (
    <footer
      style={{
        marginTop: 64,
        paddingTop: 20,
        borderTop: `1px solid ${t.border}`,
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: 12,
        color: t.muted,
      }}
    >
      (c) {new Date().getFullYear()} Hamza Ouabiba.
    </footer>
  );
}
